import TagManager from 'react-gtm-module';

class CoreService {
  getInstance() {
    return this.instance;
  }

  triggerPageView = (pathname, userId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagina: pathname,
        userId
      }
    });
  };

  createDataLayer = dataLayer => {
    TagManager.dataLayer({
      dataLayer
    });
  };

  createGlobalDataLayer = (name, data) => {
    if (window[name]) {
      window[name] = { ...window[name], ...data };
      return;
    }

    window[name] = data;
  };

  /**
   * dispatchGtm()
   *
   * @param {string} category - The event category as a string
   * @param {string} action - The event action as a string
   * @param {string} label - The event label as a string
   * @param {string} value - The event value as a string
   *
   * @example dispatchGtm("Campanha de Bônus", "Corretores", "Banner")
   * @example dispatchGtm("Campanha de Bônus", "Tomadores", "Banner")
   */
  dispatchGtm = (
    category = null,
    action = null,
    label = null,
    value = null
  ) => {
    const eventData = {
      'event-category': category,
      'event-action': action,
      'event-label': label,
      'event-value': value
    };

    TagManager.dataLayer({
      dataLayer: {
        event: 'event-trigger',
        ...eventData
      }
    });
  };
}

const services = new CoreService();
export default services;
